<template>
  <cs-basic>
    <template v-slot:header>
      <login-header />
    </template>
    <template v-slot:content>
      <div class="text-center painel">
        <h1>Ops!Página não encontrada</h1>
        <h4>Se estiver encontrado problemas entre em contato conosco.</h4>
        <img
          class="successful_link_image"
          src="../../public/img/not_found.svg"
          alt="Página não encontrada"
          v-if="isSerasa"
        />
      </div>
    </template>
    <template v-slot:footer>
      <login-footer />
    </template>
  </cs-basic>
</template>

<script>
import csBasic from '@/layouts/csBasic.vue'
import loginHeader from '@/components/header/loginHeader.vue'
import loginFooter from '@/components/loginFooter.vue'
import { mapGetters } from "vuex";
export default {
  components: {
    csBasic,
    loginHeader,
    loginFooter
  },  
  computed: {
    ...mapGetters(["isSerasa"]),    
  },
}
</script>

<style scoped>
  .successful_link_image {
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1490px) {
    .successful_link_image {
      background-repeat: no-repeat;
      width: 55%;
      height: 55%;
    }
  }
</style>
